<template>
  <div class="container">
    <Breadcrumb class="breadcrumb">
      <BreadcrumbItem to="/">
        <Icon type="ios-home" class="home" />首页
      </BreadcrumbItem>
      <BreadcrumbItem>学习中心</BreadcrumbItem>
      <BreadcrumbItem>{{ courseInfo.courseName }}</BreadcrumbItem>
      <BreadcrumbItem>课后练习</BreadcrumbItem>
    </Breadcrumb>

    <div class="practice-header">
      <div class="practice-title">
        <h1>{{ catalogInfo.catName }}</h1>
        <!-- <div class="practice-title-note">上次做题时间：2020-05-21 &emsp;&emsp; 上次正确率：0.00%</div> -->
      </div>
      <div class="practice-progress">
        <span class="practice-progress-text"
          >共 {{ this.exerciseList.length }} 道题</span
        >
        <div class="practice-progress-bar">
          <Progress :percent="progressPercent" />
        </div>
      </div>
    </div>

    <div class="practice-container clearfix">
      <div class="fl practice-main">
        <practice-item
          ref="practiceItem"
          v-for="(item, index) in exerciseList"
          :key="index"
          :data="item"
          :index="index"
          v-model="item.userKey"
          @on-check="changeProgress"></practice-item>
      </div>
      <div class="fr practice-bar">
        <Affix :offset-top="160">
          <div class="practice-sheet">
            <h3 class="practice-sheet-header">答题卡</h3>
            <p class="practice-sheet-note">点击图标跳转到对应的题目</p>
            <div class="practice-sheet-score" v-show="doResultVisible">
              <p>
                正确率
                <span class="right-rate">{{ rightPercent }}%</span>
              </p>
              <p>
                <span class="wrong-num">{{ wrongExerciseNum }}</span>
                道错题已加入错题本
              </p>
            </div>
            <div class="practice-sheet-list">
              <happy-scroll
                color="rgba(12, 154, 213 , 1)"
                size="5"
                resize
                hide-horizontal>
                <ul class="practice-sheet-serial clearfix">
                  <li
                    v-for="(item, index) in exerciseList"
                    :key="index"
                    :class="{
                      right: item.doResult == 1,
                      wrong: item.doResult == -1,
                    }">
                    <a v-text="index + 1" @click="scrollPosition(index)"></a>
                  </li>
                </ul>
              </happy-scroll>
            </div>

            <div class="practice-sheet-button">
              <Button
                v-if="!doResultVisible"
                type="warning"
                long
                @click="submitExercise"
                >提交练习</Button
              >
              <Button v-else type="warning" long @click="reloadPage"
                >重做一遍</Button
              >
            </div>
            <div class="practice-sheet-footer">
              <span>
                <i class="ivu-icon ivu-icon-md-square right"></i> 正确
              </span>
              <span>
                <i class="ivu-icon ivu-icon-md-square wrong"></i> 错误
              </span>
              <span>
                <i class="ivu-icon ivu-icon-md-square empty"></i> 未做
              </span>
            </div>
          </div>
        </Affix>
      </div>
    </div>
  </div>
</template>

<script>
import { siteMixin } from '../../utils/mixin';
import { mall, study } from '../../request';

import PracticeItem from '../../components/exercise/PracticeItem';
import { HappyScroll } from 'vue-happy-scroll';
import 'vue-happy-scroll/docs/happy-scroll.css';
export default {
  mixins: [siteMixin],
  data() {
    return {
      exerciseList: [],
      finishExerciseNum: 0,
      courseInfo: {},
      catalogInfo: {},
      wrongExerciseNum: 0,
      doResultVisible: false,
    };
  },
  computed: {
    progressPercent() {
      const totalNum = this.exerciseList.length;
      if (totalNum <= 0) return 0;
      let percent = (this.finishExerciseNum / totalNum) * 100;
      return Number(percent.toFixed(0));
    },
    rightPercent() {
      const totalNum = this.exerciseList.length;
      if (totalNum <= 0) return 0;
      let rightNum = totalNum - this.wrongExerciseNum;
      let percent = (rightNum / totalNum) * 100;
      return Number(percent.toFixed(0));
    },
  },
  mounted() {
    this.setMetaData('课后练习');
    //获取参数
    if (!this.initParams()) return;
    this.getExerciseList();
    this.getCourseInfo();
    this.getCatalogInfo();
  },
  methods: {
    initParams() {
      let courseId = this.$route.params.id;
      let umcId = this.$route.query.umcid;
      let catId = this.$route.query.catid;
      if (courseId && umcId && catId) {
        this.setCourseId(courseId);
        this.setUmcId(umcId);
        this.setCatalogId(catId);
        return true;
      } else {
        this.$Message.error('参数错误');
        return false;
      }
    },
    getExerciseList() {
      study.getVideoExerList(this.umcId, this.catalogId).then(res => {
        //console.log("videoExerList", res);
        if (res.status === 1) {
          this.exerciseList = res.data;
          this.exerciseList.forEach(item => {
            this.$set(item, 'starCount', 0);
            this.$set(item, 'userKey', '');
            this.$set(item, 'doResult', 0);
          });
        }
      });
    },
    getCourseInfo() {
      mall
        .getCourseInfo(this.courseId, 0, this.siteConfig.agencyId)
        .then(res => {
          if (res.status === 1) {
            this.courseInfo = res.data;
          }
        });
    },
    getCatalogInfo() {
      study.getCatalogInfo(this.catalogId).then(res => {
        if (res.status === 1) {
          this.catalogInfo = res.data;
        }
      });
    },
    submitExercise() {
      this.doResultVisible = true;
      //检查答案
      this.$refs.practiceItem.forEach(item => {
        item.checkAnswer();
      });
      let result = [];
      this.exerciseList.forEach(item => {
        if (item.doResult != 1 && item.userKey) {
          this.wrongExerciseNum++;
        }
        result.push({
          exerId: item.exerId,
          isRight: item.doResult == 1 ? 1 : 0,
          userKey: item.userKey,
        });
      });
      const strResult = JSON.stringify(result);
      study
        .saveVideoExer(
          this.umcId,
          this.catalogId,
          this.loginUser.userId,
          strResult,
          this.courseId,
        )
        .then(res => {
          console.log(res);
        });
    },
    changeProgress(item) {
      this.finishExerciseNum++;
    },
    scrollPosition: function (i) {
      var top = document.querySelectorAll('.practice-item')[i].offsetTop - 162;
      window.scroll({ top: top, left: 0, behavior: 'smooth' });
    },
  },
  components: {
    PracticeItem,
    HappyScroll,
  },
};
</script>

<style lang="less" scoped>
@import '../../assets/css/var';
@import '../../assets/css/exercise';
.breadcrumb {
  padding: 1rem 0;
  .home {
    vertical-align: -0.05em;
    margin-right: 0.2rem;
  }
}
</style>
